import {
  Button,
  Card,
  CardContent,
  CircularProgress,
  Input,
  MenuItem,
  Modal,
  Select,
  TextField,
} from "@material-ui/core";
import { useFormik } from "formik";
import { Check, Circle, MagnifyingGlass, UserPlus, X } from "phosphor-react";
import { useEffect, useState } from "react";
import * as yup from "yup";
import { fget } from "../../../API/callsAPI";
import SelectUserModal from "../../Utilities/ManageUsers/SelectUsersModal/SelectUserModal.component";
import UserAvatar from "../../Utilities/UserAvatar/UserAvatar.component";
import useStyles from "./PlaylistCreateNewPlaylist.styles";

const PlaylistCreateNewPlaylistModal = ({
  handleCloseModal,
  sequenceList,
  allUsers,
  project,
  createNewPlaylist,
}) => {
  const [loading, setLoading] = useState(false);
  const [selectedSeq, setSelectedSeq] = useState([]);
  const [selectedUser, setSelectedUser] = useState([]);
  const [openSequenceSelectModal, setOpenSequenceSelectModal] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [isSelectUserModalOpen, setSelectUserModalOpen] = useState(false);
  const [taskTemplateList, setTaskTemplateList] = useState([]);

  const classes = useStyles();

  //Validators
  const CreatePlaylistValidationSchema = yup.object({
    playlistName: yup
      .string("String required")
      .min(1, "Too Short!")
      .max(50, "Maximum Character Limit: 50")
      .required(),
    // accessCode: yup.number().required(),
  });

  const formik = useFormik({
    initialValues: {
      playlistName: "",
      accessCode: "Public",
      resolution: "",
      frameRate: "",
      template: "",
      average_shot_duration: 0,
    },
    validationSchema: CreatePlaylistValidationSchema,

    onSubmit: async (values) => {
      setLoading(true);
      const formDataObj = {
        sequences: selectedSeq.map((eachSeq) => eachSeq.id),
        name: formik.values.playlistName,
        access_code: formik.values.accessCode,
        project: project,
      };
      if (selectedUser.length > 0) {
        formDataObj.allowed_users = selectedUser.map((user) => user.value);
      }
      if (formik.values.resolution) {
        formDataObj.aspect_ratio = formik.values.resolution.split(",")[2];
        formDataObj.resolution_width = formik.values.resolution.split(",")[0];
        formDataObj.resolution_height = formik.values.resolution.split(",")[1];
      }
      if (formik.values.frameRate) {
        formDataObj.frame_rate = formik.values.frameRate;
      }
      if (values.template) {
        formDataObj.template = values.template;
      }
      if (values.average_shot_duration) {
        formDataObj.average_shot_duration = values.average_shot_duration;
      }

      createNewPlaylist(formDataObj);
    },
  });

  const handleSearchQuery = (e) => {
    setSearchQuery(e.target.value);
    console.log(e.target.value);
  };

  const handleSequenceSelect = (sequence) => {
    if (selectedSeq.length) {
      const exist = selectedSeq.some((eachSeq) => eachSeq.id === sequence.id);
      if (exist) {
        setSelectedSeq(
          selectedSeq.filter((eachSeq) => eachSeq.id !== sequence.id)
        );
      } else {
        setSelectedSeq([...selectedSeq, sequence]);
      }
    } else {
      setSelectedSeq([sequence]);
    }
  };

  useEffect(() => {
    getTasksTemplates();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getTasksTemplates = async () => {
    try {
      const url = `task-template/?project=${project}`;
      const res = await fget({ url });
      setTaskTemplateList(res?.data?.results);

      // setIsLoaded(true);
    } catch (error) {
      console.log(error);
      // setIsLoaded(true);
    }
  };

  return (
    <div className={classes.root}>
      <Card className={classes.card}>
        <CardContent className={classes.cardContent}>
          <form enctype="multipart/form-data" onSubmit={formik.handleSubmit}>
            <div className={classes.center}>
              <div>
                <span className={classes.title}>Create Playlist</span>
              </div>
              <Button
                style={{ minWidth: 0, minHeight: 0 }}
                onClick={handleCloseModal}
              >
                <X
                  className={classes.closeIcon}
                  style={{ width: "20px", height: "20px" }}
                />
              </Button>
            </div>
            <div className={classes.cardContentDiv1}>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <div className={classes.textFieldContainer}>
                  <span>Playlist Name</span>
                  <span style={{ color: "red", marginLeft: "5px" }}>*</span>
                  <div style={{ marginTop: "5px" }}>
                    <TextField
                      type="text"
                      multiline
                      className={classes.cardContentInput1}
                      placeholder="Enter a name"
                      InputProps={{ disableUnderline: true }}
                      value={formik.values.playlistName}
                      error={Boolean(formik.errors.playlistName)}
                      helperText={
                        formik.errors.playlistName ? (
                          <p style={{ marginTop: "-7px" }}>
                            {formik.errors.playlistName}
                          </p>
                        ) : null
                      }
                      onChange={formik.handleChange}
                      name="playlistName"
                      id="playlistName"
                    />
                  </div>
                </div>
                <div className={classes.textFieldContainer}>
                  <span
                    id="demo-multiple-select"
                    style={{ marginBottom: "4px !important" }}
                  >
                    Sequences
                  </span>
                  <span style={{ color: "red", marginLeft: "5px" }}>*</span>
                  <div
                    className={classes.cardContentInput1}
                    style={{
                      cursor: "pointer",
                      paddingTop: "8px",
                      marginTop: "5px",
                    }}
                    onClick={() => setOpenSequenceSelectModal(true)}
                  >
                    {selectedSeq.length
                      ? selectedSeq.map((eachSeq, index) =>
                          index <= 3
                            ? selectedSeq.at(-1) === eachSeq
                              ? eachSeq.code
                              : eachSeq.code + ", "
                            : index === 4
                            ? "..."
                            : ""
                        )
                      : "Select Sequences"}
                  </div>
                </div>
              </div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <div className={classes.textFieldContainer}>
                  <span>Task Template</span>
                  <div style={{ marginTop: "5px" }}>
                    <Select
                      style={{ padding: "3px" }}
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      disableUnderline
                      className={classes.cardContentInput1}
                      value={formik.values.template}
                      onChange={formik.handleChange}
                      name="template"
                      renderValue={
                        formik.values.template !== ""
                          ? undefined
                          : () => (
                              <p className={classes.placeholder}>
                                Select Template
                              </p>
                            )
                      }
                      MenuProps={{
                        getContentAnchorEl: () => null,
                        classes: {
                          paper: classes.paper,
                        },
                      }}
                      inputProps={{
                        classes: {
                          root: classes.input,
                        },
                      }}
                      displayEmpty
                    >
                      {taskTemplateList.map((template) => (
                        <MenuItem key={template.id} value={template.id}>
                          {template.name}
                        </MenuItem>
                      ))}
                    </Select>
                  </div>
                </div>
                <div className={classes.textFieldContainer}>
                  <span>Avg Shot Duration</span>
                  <div style={{ marginTop: "5px" }}>
                    <TextField
                      type="number"
                      multiline
                      className={classes.cardContentInput1}
                      placeholder="Enter a name"
                      InputProps={{ disableUnderline: true }}
                      value={formik.values.average_shot_duration}
                      error={Boolean(formik.errors.average_shot_duration)}
                      helperText={
                        formik.errors.average_shot_duration ? (
                          <p style={{ marginTop: "-7px" }}>
                            {formik.errors.average_shot_duration}
                          </p>
                        ) : null
                      }
                      onChange={formik.handleChange}
                      name="average_shot_duration"
                      id="average_shot_duration"
                    />
                  </div>
                </div>
              </div>

              <div className={classes.textFieldContainer}>
                <span>Select Users</span>
                <div
                  style={{
                    marginTop: "5px",
                    display: "flex",
                    justifyContent: "space-between",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                    }}
                  >
                    {selectedUser.length ? (
                      selectedUser.map((user) => (
                        <div
                          style={{
                            marginRight: "10px",
                          }}
                          key={user.value}
                        >
                          <UserAvatar
                            avatar={user?.avatar}
                            firstName={user?.label?.split(" ")[0]}
                            lastName={user?.label?.split(" ")[1]}
                          />
                        </div>
                      ))
                    ) : (
                      <div></div>
                    )}
                  </div>
                  <Button
                    style={{
                      marginTop: "-10px",
                      minHeight: 0,
                      minWidth: 0,
                      marginRight: "-5px",
                    }}
                    onClick={() =>
                      setSelectUserModalOpen(!isSelectUserModalOpen)
                    }
                  >
                    <UserPlus className={classes.userPlusIcon} />
                  </Button>
                </div>
              </div>
              <div className={classes.textFieldContainer}>
                <span>Timeline Settings</span>
                <hr className={classes.hrTimeline} />
              </div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <div className={classes.textFieldContainer}>
                  <span>Resolution</span>
                  <div style={{ marginTop: "5px" }}>
                    <Select
                      style={{ padding: "3px" }}
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      disableUnderline
                      className={classes.cardContentInput1}
                      value={formik.values.resolution}
                      onChange={formik.handleChange}
                      renderValue={
                        formik.values.resolution !== ""
                          ? undefined
                          : () => (
                              <p className={classes.placeholder}>
                                Select Resolution
                              </p>
                            )
                      }
                      name="resolution"
                      MenuProps={{
                        getContentAnchorEl: () => null,
                        classes: {
                          paper: classes.paper,
                        },
                      }}
                      inputProps={{
                        classes: {
                          root: classes.input,
                        },
                      }}
                      displayEmpty
                    >
                      <MenuItem value="1920,1080,16:9">
                        1920 X 1080 (16:9)
                      </MenuItem>
                      <MenuItem value="1540,920,12:5">
                        1540 X 920 (12:5)
                      </MenuItem>
                    </Select>
                  </div>
                </div>
                <div className={classes.textFieldContainer}>
                  <span>FrameRate</span>
                  <div style={{ marginTop: "5px" }}>
                    <TextField
                      type="number"
                      value={formik.values.frameRate}
                      onChange={formik.handleChange}
                      name="frameRate"
                      InputProps={{ disableUnderline: true }}
                      className={classes.cardContentInput1}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                marginTop: "10px",
              }}
            >
              <Button
                className={classes.submitBtn}
                type="submit"
                value="Submit"
                size="small"
                disableElevation
              >
                {loading ? (
                  <CircularProgress size={23} className={classes.closeIcon} />
                ) : (
                  <b>Create Playlist</b>
                )}
              </Button>
            </div>
          </form>
        </CardContent>
      </Card>
      <div>
        <Modal
          open={openSequenceSelectModal}
          onClose={() => setOpenSequenceSelectModal(false)}
          className={classes.center}
        >
          <div className={classes.sequenceModal}>
            <div className={classes.toolContainer}>
              <div className={classes.searchDiv}>
                <MagnifyingGlass size={25} style={{ marginLeft: "2%" }} />
                <Input
                  className={classes.searchInput}
                  disableUnderline="false"
                  placeholder="Search anything"
                  onChange={(e) => handleSearchQuery(e)}
                />
              </div>
              <div>
                <X
                  size={27}
                  className={classes.seqModalCloseIcon}
                  onClick={() => setOpenSequenceSelectModal(false)}
                />
              </div>
            </div>
            <div className={classes.sequenceList}>
              {sequenceList && sequenceList.count !== 0
                ? sequenceList.results
                    ?.filter((search) => {
                      if (searchQuery === undefined) {
                        return search;
                      } else if (searchQuery === "") {
                        return search;
                      } else if (
                        search.code
                          ?.toLowerCase()
                          .includes(searchQuery.toLowerCase())
                      ) {
                        return search;
                      } else return null;
                    })
                    .map((sequence) => (
                      <>
                        <div
                          className={classes.singleSequence}
                          key={sequence}
                          onClick={() => {
                            handleSequenceSelect(sequence);
                          }}
                        >
                          {selectedSeq?.map((eachSeq) =>
                            eachSeq?.id === sequence?.id ? (
                              <div
                                style={{
                                  position: "absolute",
                                  marginTop: "3px",
                                  marginLeft: "2px",
                                }}
                              >
                                <Check size={25} className={classes.check} />
                              </div>
                            ) : (
                              ""
                            )
                          )}

                          <Circle size={25} className={classes.check} />
                          {sequence.code}
                        </div>
                        {sequenceList.results.at(-1) === sequence ? (
                          ""
                        ) : (
                          <hr className={classes.hrSeq} />
                        )}
                      </>
                    ))
                : "No Sequences"}
            </div>
            <div className={classes.seqButtonDiv}>
              <Button
                className={classes.seqButton}
                onClick={() => setOpenSequenceSelectModal(false)}
              >
                Done
              </Button>
            </div>
          </div>
        </Modal>
      </div>
      <div>
        <Modal
          className={classes.modal}
          open={isSelectUserModalOpen}
          onClose={() => setSelectUserModalOpen(!isSelectUserModalOpen)}
        >
          <SelectUserModal
            closeModal={() => setSelectUserModalOpen(!isSelectUserModalOpen)}
            assignedUser={selectedUser}
            usersList={allUsers}
            handleSelectUsers={(users) => setSelectedUser(users)}
          />
        </Modal>
      </div>
    </div>
  );
};

export default PlaylistCreateNewPlaylistModal;
